var map = {
	"./blip.png": "e9fe",
	"./bluesky.png": "4b18",
	"./facebook.png": "07b3",
	"./googlemybusiness.png": "ee5a",
	"./googleplay.png": "fed3",
	"./instagram.png": "a671",
	"./linkedin.png": "cd2a",
	"./tiktok.png": "f8aa",
	"./twitter.png": "a302",
	"./twitterdark.png": "6e07",
	"./youtube.png": "dcff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0808";